<template>
    <div class="info-modal hide study-design">

        <div class="info-modal-content">
            <button class="close-btn" @click="closeModal"><img src="@/assets/img/modal/close.svg" /></button>

            <div class="study-design-header">
                <span class="section-title">Study Design and Baseline Characteristics</span>
                <p>Children aged 6 to 12 years (N=117) with ADHD1</p>
            </div>
            <vue-custom-scrollbar class="scroll-area" :settings="settings">
                <div class="img-wrapper">
                    <img src="@/assets/img/efficacy/study-design.png" alt="Graphic showing a table layout of the study"
                        class="sd-img" />
                </div>
            </vue-custom-scrollbar>

            <div class="mobile-content">
                <b>Scroll to see more</b>
            </div>

            <div class="info">
                <p>At baseline, 39% of study participants† were considered to be moderately ill, 42% were markedly ill,
                    and 18% were severely ill, with 1% being among the most extremely ill participants, per the CGI-S
                    assessment</p>
                <hr />
                <p>The mean CGI-P total score at baseline was 22.<sup>1†</sup></p>
                <hr />
                <p>At randomization, the JORNAY PM cohort had a slightly more severe population</p>
                <hr />
                <p>Age-appropriate, norm-referenced percentile cutoffs for the severity of functional impairment were
                    applied to measures of early morning and late afternoon/evening functional impairment for each
                    participant</p>

            </div>

            <div class="refs">
                <p>CGI-P, Conners’ Global Index-Parent Version; CGI-S, Clinical Global Impression-Severity.<br />
                    <span>*</span>Participants were withdrawn from their current ADHD medication for ≥5 days before staring
                    the
                    open-label, treatment-optimization phase. <br />
                    <span><sup>†</sup></span>Enrolled Safety Population; n=125.
                </p>
                <p><b>Reference: 1.</b> Childress AC, Cutler AJ, Marraffino A, et al. A randomized, double-blind,
                    placebo-controlled study of HLD200, a delayed-release and extended-release methylphenidate, in children
                    with attention-deficit/hyperactivity disorder: an evaluation of safety and efficacy throughout the day
                    and across settings. <i>J Child Adolesc Psychopharmacol.</i> 2020;30(1):2-14.</p>
            </div>


        </div>
    </div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import "vue-custom-scrollbar/dist/vueScrollbar.css"

export default {


    props: {
        showModal: {
            type: Boolean,
            default: false
        }
    },
    components: {
        vueCustomScrollbar
    },
    data() {
        return {
            settings: {
                suppressScrollY: true,
                suppressScrollX: false,
                wheelPropagation: true
            },
        }
    },
    mounted() {
        if (this.showModal == true) {
            document.body.classList.add("overflow")
            this.$el.classList.remove('hide')
        }



    },
    watch: {
        showModal(newValue, oldValue) {

            if (newValue === true) {
                this.modalActive();
            }
        }
    },

    methods: {
        modalActive: function () {
            document.body.classList.add("overflow")
            this.$el.classList.remove('hide')
        },

        closeModal() {
            document.body.classList.remove("overflow")
            this.$el.classList.add('hide')
            this.$emit('closeModal')
        }
    }

}
</script>